import { Document, Page, View, Text, StyleSheet, PDFDownloadLink, Link } from "@react-pdf/renderer";
import dayjs from "dayjs";
const HEADER_H = 90;     // title + subtitle approx
const THEAD_H = 30;     // table headings approx
const TOP_SPACE = HEADER_H + THEAD_H + 16; // body ke liye top gap

const styles = StyleSheet.create({
    page: { paddingTop: TOP_SPACE, paddingHorizontal: 20, paddingBottom: 40, fontSize: 9, },

    fixedHeader: { position: "absolute", top: 20, left: 20, right: 20 },

    title: { fontSize: 16, fontWeight: "bold", marginBottom: 2 },

    subTitle: { flexDirection: "row", justifyContent: "space-between", },

    subTitleText: { fontSize: 10, },

    thead: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderColor: "#555",
        backgroundColor: "#f0f0f0",
        paddingVertical: 4,
        marginTop: 8,
    },
    th: { fontWeight: "bold", paddingHorizontal: 3, borderRightWidth: 1, borderColor: "#ccc", lineHeight: 1 },

    tr: { flexDirection: "row", borderBottomWidth: 1, borderColor: "#eee" },

    td: { paddingHorizontal: 3, paddingVertical: 2, borderRightWidth: 1, borderColor: "#f2f2f2", lineHeight: 0.9 },

    c_punch_date: { flex: 10 },
    c_in: { flex: 10 }, c_out: { flex: 10 }, c_att: { flex: 10 }, c_late: { flex: 8 }, c_early: { flex: 8 },

    // footer: { position: "absolute", bottom: 10, left: 0, right: 0, textAlign: "center", fontSize: 9, color: "#666" },
    footerBar: {
        position: "absolute",
        bottom: 10,
        left: 20,
        right: 20,
        flexDirection: "row",
        justifyContent: "space-between",
        fontSize: 9,
    },
});

const AttendanceReportDoc = ({ data, title = "Daily Attendance Report", company = "WHD", reportDate }) => (
    <Document>
        <Page size="A4" orientation="portrait" style={styles.page}>
            {/* 🔁 Header + Table Headings repeat on every page */}
            <View style={styles.fixedHeader} fixed>
                <Text style={styles.title}>{company}</Text>
                <View fixed style={styles.subTitle}>
                    <Text style={[styles.subTitleText, { fontSize: 12, fontWeight: 'bold' }]}>{title}</Text>
                    <Text style={styles.subTitleText}>Report For The Month : {reportDate}</Text>
                </View>
                <View fixed style={[styles.subTitle, { marginTop: 4 }]}>
                    <Text style={styles.subTitleText}>Unit : {data[0].unitDescription}</Text>
                    <Text style={styles.subTitleText}>Deptarment : {data[0].deptName}</Text>
                    <Text style={styles.subTitleText}>Shift : {data[0].shiftName}</Text>
                </View>
                <View style={styles.thead}>
                    {/* <Text style={[styles.th, styles.c_unit]}>Unit</Text>
                    <Text style={[styles.th, styles.c_emp]}>Employee</Text>
                    <Text style={[styles.th, styles.c_dept]}>Department</Text> */}
                    <Text style={[styles.th, styles.c_punch_date]}>Date</Text>
                    <Text style={[styles.th, styles.c_in]}>Time In</Text>
                    <Text style={[styles.th, styles.c_out]}>Time Out</Text>
                    <Text style={[styles.th, styles.c_att]}>Status</Text>
                    <Text style={[styles.th, styles.c_late]}>Late</Text>
                    <Text style={[styles.th, styles.c_early]}>Early Out</Text>
                    <Text style={[styles.th, styles.c_early]}>In Time Short Excess</Text>
                    <Text style={[styles.th, styles.c_early]}>Out Time Short Excess</Text>
                    <Text style={[styles.th, styles.c_early]}>Adjustments</Text>
                </View>
            </View>

            {/* 🧾 Body — no manual marginTop, no chunking */}
            <View>
                {data.map((row, idx) => (
                    <View key={idx} style={styles.tr}>
                        {/* <Text style={[styles.td, styles.c_unit]}>{row.unitDescription}</Text>
                        <Text style={[styles.td, styles.c_emp]}>{row.empName} {row.user_pin ? `(${row.user_pin})` : ""}</Text>
                        <Text style={[styles.td, styles.c_dept]}>{row.deptName || "-"}</Text> */}
                        <Text style={[styles.td, styles.c_punch_date]}>{dayjs(row.punch_date).format('DD-MMM-YYYY') || "-"}</Text>
                        <Text style={[styles.td, styles.c_in]}>{row.time_in || "-"}</Text>
                        <Text style={[styles.td, styles.c_out]}>{row.time_out || "-"}</Text>
                        <Text style={[styles.td, styles.c_att]}>{row.attendance_status || "-"}</Text>
                        <Text style={[styles.td, styles.c_late]}>{row.late_in_status || "-"}</Text>
                        <Text style={[styles.td, styles.c_early]}>{row.early_out_status || "-"}</Text>
                        <Text style={[styles.td, styles.c_early]}>{row.formatted_time_inTime || "-"}</Text>
                        <Text style={[styles.td, styles.c_early]}>{row.formatted_time_outTime || "-"}</Text>
                        <Text style={[styles.td, styles.c_early]}>{row.formatted_time_adjustments || "-"}</Text>
                    </View>
                ))}
            </View>

            {/* 📄 Page X of Y on every page */}
            <View fixed style={styles.footerBar}>
                <Text render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`} />
                <Link src="https://whdevs.com" style={styles.footerLink}>Developed By : WHD</Link>
            </View>
        </Page>
    </Document >
);


export default function AttendanceReportPDF({ data, title, fileName, reportDate, company }) {
    const now = new Date();
    const defaultName = fileName || `Attendance_${now.toISOString().split("T")[0]}.pdf`;

    return (
        <PDFDownloadLink
            document={
                <AttendanceReportDoc
                    data={data}
                    title={title}
                    company={company}
                    reportDate={reportDate}
                />
            }
            fileName={defaultName}
            style={{
                padding: "8px 14px",
                backgroundColor: "#1E90FF",
                border: "1px solid #1976d2",
                borderRadius: 6,
                textDecoration: "none",
                color: "#FFF",
                fontSize: 20,
                width: 200,
                textAlign: "center",
            }}
        >
            {({ loading }) => (loading ? "Preparing PDF..." : "Print")}
        </PDFDownloadLink>
    );
}
